import React from 'react';

export const SocketContext = React.createContext();
